/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noanalyticsdataavailable3Inputs */

const en_noanalyticsdataavailable3 = /** @type {(inputs: Noanalyticsdataavailable3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No analytics data available`)
};

const de_noanalyticsdataavailable3 = /** @type {(inputs: Noanalyticsdataavailable3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Statistiken verfügbar.`)
};

/**
* | output |
* | --- |
* | "No analytics data available" |
*
* @param {Noanalyticsdataavailable3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const noanalyticsdataavailable3 = /** @type {((inputs?: Noanalyticsdataavailable3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noanalyticsdataavailable3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_noanalyticsdataavailable3(inputs)
	return de_noanalyticsdataavailable3(inputs)
});
export { noanalyticsdataavailable3 as "noAnalyticsDataAvailable" }